// extracted by mini-css-extract-plugin
module.exports = {"tab-list":"tabs_tab-list__1d_vK","tab-list-item":"tabs_tab-list-item__CaCGk","is-active":"tabs_is-active__ER_YO"};